import { BaseSystemModel, Guid, RecursivePartial } from "@models/base";

export enum MilestoneStatus {
    Unknown    = 0,
    InProgress = 1,
    Paused     = 2,
    Canceled   = 3,
    Finished   = 4,
}

export enum MilestoneProgressType {
    TasksCount    = 0,   // по количеству заверешенных задач
    TasksTime     = 1,   // по суммарному времени завершенных задач
}

export class Milestone extends BaseSystemModel {
    orgId: Guid = '';
    projectId: Guid = '';
    assignee: Guid = '';

    name: string = '';
    description?: string;

    dueDate: Date = new Date();
    tagIds?: Guid[];
    progressCalcType: MilestoneProgressType = MilestoneProgressType.TasksCount;

    readonly taskIds?: Guid[];                       // readonly, filled on backend

    readonly approved?: Date;                        // readonly, filled on backend
    readonly approvedBy?: Guid;                      // readonly, filled on backend

    readonly tasksTotal: number = 0; // Math.trunc(Math.random() * 100);                     // readonly, filled on backend
    readonly tasksDone: number = 0; // Math.trunc(Math.random() * this.tasksTotal);                      // readonly, filled on backend

    _overdue?: boolean;
    _overdueDays: number = 0;
    _proc: number = 0;

    constructor(json?: RecursivePartial<Milestone>) {
        super(json);
        this.parseMilestone(json || {});
    }

    parse(json: RecursivePartial<Milestone>): Milestone {
        super.parse(json);
        this.parseMilestone(json);
        return this;
    }

    private parseMilestone(json: RecursivePartial<Milestone>): void {
        Milestone.assignFields(this, json, [
            'orgId',
            'projectId',
            'assignee',
            'name',
            'description',
            'tagIds',
            'progressCalcType',
            'taskIds',
            'approvedBy',
            'tasksDone',
            'tasksTotal',
        ]);
        Milestone.assignDates(this, json, ['dueDate', 'approved']);
        this._proc = this.tasksTotal > 0 ? Math.trunc(100 / this.tasksTotal * this.tasksDone) : 0;
        const ndt = this.approved?.getTime() || Date.now();
        const ddt = this.dueDate.getTime();
        if (ddt) {
            const ndtDays = Math.trunc(ndt / 1000 / 60 / 60 / 24);
            const ddtDays = Math.trunc(ddt / 1000 / 60 / 60 / 24);
            this._overdueDays = ndtDays - ddtDays;
            this._overdue = this._overdueDays > 0;
        }
    }

}
